import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"
import * as styles from "./__styles__/image.module.scss"

export default function Image({ image }) {
  return (
    <div className={styles.container}>
      <GatsbyImage
        image={image.localFile.childImageSharp.gatsbyImageData}
        alt={image.altText}
        className={styles.imageWrapper}
      />
    </div>
  )
}

Image.propTypes = {
  /**
   * An array with the image's data
   */
  image: PropTypes.shape({
    id: PropTypes.string.isRequired,
    altText: PropTypes.string,
  }),
}
